import { render, staticRenderFns } from "./talent9.vue?vue&type=template&id=45dce470&scoped=true"
import script from "./talent9.vue?vue&type=script&lang=js"
export * from "./talent9.vue?vue&type=script&lang=js"
import style0 from "./talent9.vue?vue&type=style&index=0&id=45dce470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dce470",
  null
  
)

export default component.exports